app.mediator.registerModule(MODULE_NAME__GEO_SELECT, function(app) {
    return {

        $rootElem: null,
        lastOpenedByElem: null,

		//==========================================================xdiv2====
		// Start and stop
		//===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

		init: function() {

			// Init
			var scope = this;
            this.$rootElem = $('.mod-geo-select');
            if (!this.$rootElem.length) return;
            scope.addDomListeners();
            scope.addMediatorListeners();
		},

        addDomListeners: function () {
            var scope = this;
			this.$rootElem.find('.gsm-close-btn').click(function() {
				scope.hide();
			});
            $(document).keyup(function (e) {
                if (e.keyCode == 27) { // esc
                    scope.hide();
                }
            });
        },

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__AUXNAV__LANGUAGE_SELECT_BUTTON_CLICKED, function (data) {
                scope.lastOpenedByElem = data.target;
                scope.show();
            });
            app.mediator.addListener(EVENT_NAME__MAIN_NAV__LANGUAGE_SELECT_BUTTON_CLICKED, function (data) {
                scope.lastOpenedByElem = data.target;
                scope.show();
            });
        },
		
		//==========================================================xdiv2====
		// Module
		//===================================================================

        goToStart: function () {
            this.$rootElem.find('.gsm-close-btn').focus();
        },

        show: function () {
            $('html, body').animate({ scrollTop: 0 }, 200);
			this.$rootElem.addClass('active');
            this.goToStart();
            app.mediator.notify(EVENT_NAME__GEO_SELECT__OPENED);
		},

        hide: function (notify) {
            var scope = this;
            notify = typeof notify !== 'undefined' ? notify : true;
			this.$rootElem.removeClass('active');
            if (notify) {
                app.mediator.notify(EVENT_NAME__GEO_SELECT__CLOSED, {
                    lastOpenedByElem: scope.lastOpenedByElem
                });
            }
		},

		toggle: function() {
            if (this.$rootElem.hasClass('active')) {
                this.hide();
            } else {
                this.show();
            }
		}

	};
});